import { useNavigate } from 'react-router'
import { baseUrl } from '.'

/** Navigates to return URL using react-router when possible (return url is internal) */
export const useReturnUrlNavigate = () => {
    const navigate = useNavigate()

    return (returnUrl: string) => {
      const appUrl = `${window.location.origin}/${baseUrl}`
      const navigateUrl = returnUrl?.replace(appUrl, '/') ?? '/'
      const isExternal = navigateUrl?.startsWith('http') && !!returnUrl
      
      if (isExternal) {
        console.debug('Navigating to external url: ', navigateUrl)
        window.location.href = navigateUrl
      }
      else {
        console.debug('Navigating to internal url: ', navigateUrl)
        navigate(navigateUrl, { replace: true })
      }
    }
}